import { LoadingButton } from '@mui/lab';
import { Box, Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
import { GeneralSelectMenu } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

const statusList = [
  { title: 'همه', id: '-1' },
  { title: 'فعال', id: '1' },
  { title: 'غیر فعال', id: '2' },
  { title: 'حذف شده', id: '3' },
];

export default function DuelTableToolbar({ onChangePage, setFilterItems }) {
  const { projectId } = useParams();
  const [duelListFilters, setDuelListFilters] = useLocalStorage('duelListFilters');

  const [selectedStatus, setSelectedStatus] = useState(duelListFilters?.IsActive || -1);

  const defaultValues = {
    ...duelListFilters,
  };

  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;

  const resetFilters = () => {
    const initialFilterItems = {
      AppID: +projectId,
      Title: '',
      IsActive: -1,
    };

    setFilterItems(initialFilterItems);
    setDuelListFilters(initialFilterItems);

    setValue('Title', '');
    setSelectedStatus(-1);
  };

  const onSubmit = async (values) => {
    const PAYLOAD = {
      ...values,
      AppID: +projectId,
      IsActive: +selectedStatus,
    };

    setDuelListFilters(PAYLOAD);

    setFilterItems(PAYLOAD);

    onChangePage(null, 0);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 3,
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gridAutoRows: '56px',
        }}
      >
        <RHFTextField name="Title" type="text" label="عنوان" />

        <GeneralSelectMenu
          label="وضعیت تورنومنت"
          name="IsActive"
          options={statusList}
          value={selectedStatus}
          onChangeValue={setSelectedStatus}
        />

        <div className="flex gap-2 w-full">
          <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting} sx={{ height: '55px', width: '100%' }}>
            جستجو
          </LoadingButton>

          <Tooltip title="بازنشانی فیلترها">
            <Button color="error" variant="outlined" onClick={resetFilters}>
              <Iconify icon={'eva:trash-2-outline'} sx={{ fontSize: '20px' }} />
            </Button>
          </Tooltip>
        </div>
      </Box>
    </FormProvider>
  );
}
